// extracted by mini-css-extract-plugin
module.exports = {"bankField":"BankAccountDetails_bankField__1_zZs"};